import { render } from "./CreateNotification.vue?vue&type=template&id=7133c702"
import script from "./CreateNotification.vue?vue&type=script&lang=js"
export * from "./CreateNotification.vue?vue&type=script&lang=js"

import "./styles.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__